import React from 'react';

const QuoteUpdateContext = React.createContext(null);

export const QuoteUpdateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <QuoteUpdateContext.Provider value={null}>
            {children}
        </QuoteUpdateContext.Provider>
    );
};

export const useQuoteUpdate = () => {
    return React.useContext(QuoteUpdateContext);
};
